<template>
	<div class="safetyInformation">
		<field
				margin="0"
				min-height="100px"
				width="100%"
				label="Safety Service Info"
				placeholder="Enter information"
				:setInputValue="localInformation"
				@updateInput="onInput"
				is-auto-grow
				is-textarea
		></field>

		<div class="safetyInformation__bottom">
			<small>
				Displayed in the table where the CustomerLink component is used
			</small>

			<v-btn
					color="primary"
					:loading="isLoading"
					:disabled="isLoading"
					@click="onSave"
			>
				Save
			</v-btn>
		</div>
	</div>
</template>

<script>
import { saveSafetyInformation } from "@/services/safetyService";

export default {
	name: "SafetyInformation",

	props: {
		information: {
			type: String,
			default: ""
		},

		endpoint: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			localInformation: this.information,
			isLoading: false
		};
	},

	watch: {
		information(value) {
			this.localInformation = value || "";
		}
	},

	methods: {
		onInput({ value }) {
			this.localInformation = value;
			this.$emit("update", value);
		},

		async onSave() {
			this.isLoading = true;

			try {

				const data = await saveSafetyInformation( this.endpoint, this.localInformation );

				this.$emit("saved", data);

				this.$store.dispatch("setAlert", {
					type: "success",
					message: "Safety information saved successfully"
				});
			} catch (error) {
				console.error(error);

				this.$store.dispatch("setAlert", {
					type: "error",
					message: "Failed to save safety information"
				});
			} finally {
				this.isLoading = false;
			}
		}
	}
};
</script>

<style scoped lang="scss">
.safetyInformation {
	width: 100%;

	&__bottom {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 15px;
		margin-top: 10px;

		small {
			margin: 0;
		}
	}

	@media (max-width: 767px) {
		&__bottom {
			align-items: flex-start;
			flex-direction: column;
		}
	}
}
</style>
